import { Auth, API } from 'aws-amplify';
import { apiGateway, manageGateway } from './config';

const ApiHeaders = async path => {
  const session = await Auth.currentSession();
  const token = path === 'upstate'
    ? session.getAccessToken().getJwtToken()
    : session.getIdToken().getJwtToken();

  return {
    ...apiGateway.apiInit.headers,
    Authorization: `Bearer ${token}`
  };
};

const createApiInit = async (options, path, gateway = apiGateway) => ({
  ...gateway.apiInit,
  ...options,
  headers: await ApiHeaders(path)
});

const ApiGet = async (path, queryStringParameters = undefined) => {
  const init = await createApiInit(
    queryStringParameters ? { queryStringParameters } : undefined,
    path
  );

  return API.get(apiGateway.apiName, apiGateway.apiPath + path, init);
};

const ApiGetNoWait = async path => {
  const init = await createApiInit(undefined, path);
  return API.get(apiGateway.apiName, apiGateway.apiPath + path, init);
};

const ApiGetArray = async getArray => {
  return Promise.all(
    getArray.map(async path => API.get(apiGateway.apiName, apiGateway.apiPath + path, await createApiInit(undefined, path)))
  );
};

const ApiCall = async item => {
  const path = apiGateway.apiPath + item.resource;

  if (item.method === 'POST') {
    const init = await createApiInit({ body: item.body }, item.resource);
    return API.post(apiGateway.apiName, path, init);
  }

  const init = await createApiInit(undefined, item.resource);
  return API.get(apiGateway.apiName, path, init);
};

const ApiCallArray = async callArray => {
  const calls = Array.isArray(callArray) ? callArray : [callArray];
  return Promise.all(calls.map(ApiCall));
};

const ApiPost = async (path, body) => {
  const init = await createApiInit({ body }, path);
  return API.post(apiGateway.apiName, apiGateway.apiPath + path, init);
};

const ManageApiGet = async (path, queryStringParameters = undefined) => {
  const init = await createApiInit(
    queryStringParameters ? { queryStringParameters } : undefined,
    path,
    manageGateway
  );
  return API.get(manageGateway.apiName, manageGateway.apiPath + path, init);
};

const ManageApiPost = async (path, body) => {
  const init = await createApiInit({ body }, path, manageGateway);
  return API.post(manageGateway.apiName, manageGateway.apiPath + path, init);
};

export { ApiGet, ApiGetNoWait, ApiGetArray, ApiCallArray, ApiHeaders, ApiPost, ManageApiGet, ManageApiPost };
